(function() {
  function money(cents, currencyCode) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || document.body.dataset.shopCurrency || 'AUD'
    }).format(amount);
  }

  function getJson(url, options) {
    return fetch(url, options).then(function(response) {
      if (!response.ok) {
        throw new Error('Request failed');
      }
      return response.json();
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function safeImageUrl(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    if (raw.indexOf('//') === 0) return escapeAttribute(raw);

    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
        return escapeAttribute(raw);
      }
    } catch (error) {}

    return '';
  }

  function safeQuantity(value) {
    var quantity = Number(value);
    if (!Number.isFinite(quantity)) return 0;
    return Math.max(0, Math.floor(quantity));
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(node) {
      node.textContent = count;
    });
  }

  function updateShippingBar(totalPriceInCents, currencyCode) {
    var threshold = Number(document.body.dataset.freeShippingThreshold || 0);
    if (!threshold) return;

    var thresholdCents = threshold * 100;
    var remaining = thresholdCents - Number(totalPriceInCents || 0);
    var progress = Math.min(100, (Number(totalPriceInCents || 0) / thresholdCents) * 100);
    var qualified = remaining <= 0;

    document.querySelectorAll('[data-shipping-bar]').forEach(function(bar) {
      bar.setAttribute('data-qualified', String(qualified));

      var messageEl = bar.querySelector('[data-shipping-bar-message]');
      if (messageEl) {
        if (qualified) {
          messageEl.innerHTML = "You\u2019ve unlocked <strong>FREE</strong> shipping";
        } else {
          messageEl.innerHTML =
            "You\u2019re <strong>" + money(remaining, currencyCode) + "</strong> away from <strong>FREE</strong> shipping";
        }
      }

      var fillEl = bar.querySelector('[data-shipping-bar-fill]');
      if (fillEl) {
        fillEl.style.width = progress + '%';
      }
    });
  }

  function cartItemMarkup(item, currencyCode) {
    const title = escapeHtml(item.product_title || item.title || '');
    const key = escapeAttribute(item.key || '');
    const quantity = safeQuantity(item.quantity);
    const imageUrl = safeImageUrl(item.image);
    const image = imageUrl
      ? '<img class="drawer-item__image" src="' + imageUrl + '" alt="' + escapeAttribute(item.product_title || item.title || '') + '" loading="lazy" width="90" height="110">'
      : '<div class="drawer-item__image"></div>';

    const options = (item.options_with_values || [])
      .filter(function(option) {
        return option.value && option.value !== 'Default Title';
      })
      .map(function(option) {
        return '<p class="drawer-item__meta">' + escapeHtml(option.name) + ': ' + escapeHtml(option.value) + '</p>';
      })
      .join('');

    const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? '<p class="drawer-item__meta">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</p>'
      : '';

    return (
      '<article class="drawer-item">' +
      image +
      '<div class="drawer-item__details">' +
      '<h3>' + title + '</h3>' +
      options +
      plan +
      '<p class="drawer-item__meta">' + money(item.final_line_price, currencyCode) + '</p>' +
      '</div>' +
      '<div class="stack">' +
      '<div class="qty-stepper">' +
      '<button type="button" class="qty-stepper__btn" data-qty-minus data-key="' + key + '" aria-label="Decrease quantity">' +
      '<svg width="10" height="2" viewBox="0 0 10 2" fill="none" aria-hidden="true"><path d="M0 1h10" stroke="currentColor" stroke-width="1.3"/></svg>' +
      '</button>' +
      '<label class="visually-hidden" for="drawer-qty-' + key + '">Quantity</label>' +
      '<input id="drawer-qty-' + key + '" class="qty-stepper__input" type="number" min="0" value="' + quantity + '" data-cart-quantity data-key="' + key + '">' +
      '<button type="button" class="qty-stepper__btn" data-qty-plus data-key="' + key + '" aria-label="Increase quantity">' +
      '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M5 0v10M0 5h10" stroke="currentColor" stroke-width="1.3"/></svg>' +
      '</button>' +
      '</div>' +
      '<button class="drawer-item__remove" type="button" data-cart-remove data-key="' + key + '">Remove</button>' +
      '</div>' +
      '</article>'
    );
  }

  function renderCart(cart) {
    const itemsTarget = document.querySelector('[data-cart-items]');
    const subtotalTarget = document.querySelector('[data-cart-subtotal]');
    if (!itemsTarget || !subtotalTarget) return;

    if (!cart.items.length) {
      itemsTarget.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
    } else {
      itemsTarget.innerHTML = cart.items.map(function(item) {
        return cartItemMarkup(item, cart.currency);
      }).join('');
    }

    subtotalTarget.textContent = money(cart.total_price, cart.currency);
    setCartCount(cart.item_count);
    updateShippingBar(cart.total_price, cart.currency);
  }

  function closePdpMobileSheets() {
    document.body.classList.remove('pdp-mobile-sheet-opening', 'pdp-mobile-sheet-open', 'pdp-mobile-sheet-closing');
    document.querySelectorAll('[data-pdp-mobile-sheet]').forEach(function(sheet) {
      sheet.classList.remove('is-opening', 'is-open', 'is-closing');
      sheet.setAttribute('aria-hidden', 'false');
    });
  }

  function openCart() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    closePdpMobileSheets();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-cart-open');
    refreshCart();
  }

  function closeCart() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-cart-open');
  }

  function refreshCart() {
    getJson('/cart.js').then(renderCart).catch(function() {});
  }

  function syncProductForm(form) {
    const jsonNode = form.querySelector('[data-product-json]');
    const variantInput = form.querySelector('[name="id"]');
    const priceTarget = form.querySelector('[data-product-price]');
    if (!jsonNode || !variantInput) return;

    if (form.querySelector('[data-selling-plan-picker]') || form.querySelector('[data-selling-plan-input]')) {
      return;
    }

    const variants = JSON.parse(jsonNode.textContent);
    const optionInputs = form.querySelectorAll('[data-option-input]');

    function updateVariant() {
      const selected = {};
      optionInputs.forEach(function(input) {
        if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') {
          selected[input.dataset.optionPosition] = input.value;
        }
      });

      const matched = variants.find(function(variant) {
        return [variant.option1, variant.option2, variant.option3].every(function(value, index) {
          const key = String(index + 1);
          return !selected[key] || selected[key] === value;
        });
      });

      if (!matched) return;
      variantInput.value = matched.id;
      if (priceTarget) {
        priceTarget.textContent = money(matched.price, document.body.dataset.shopCurrency);
      }
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();
  }

  function isProductForm(form) {
    if (!form) return false;
    return form.classList.contains('pdp-form') || form.classList.contains('product-form');
  }

  function formHasOneTimePurchaseSelected(form) {
    const checkedPurchaseType = form && form.querySelector('[data-plan-type]:checked');
    const sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');
    return !!(
      checkedPurchaseType &&
      checkedPurchaseType.dataset.planType === 'onetime' &&
      sellingPlanInput
    );
  }

  function submitProductForm(form) {
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.setAttribute('aria-busy', 'true');
    const formData = new FormData(form);
    if (formHasOneTimePurchaseSelected(form)) {
      formData.delete('selling_plan');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Unable to add to cart');
        }
        return response.json();
      })
      .then(function() {
        openCart();
      })
      .catch(function(error) {
        const errorTarget = form.querySelector('[data-product-error]');
        if (errorTarget) {
          errorTarget.hidden = false;
          errorTarget.textContent = error.message;
        }
      })
      .finally(function() {
        if (submitButton) submitButton.removeAttribute('aria-busy');
      });
  }

  let loyaltyRates;

  function fetchLoyaltyRates() {
    if (loyaltyRates) return Promise.resolve(loyaltyRates);

    const appUrl = document.body.dataset.loyaltyAppUrl;
    const shop = document.body.dataset.permanentDomain;
    if (!appUrl || !shop) return Promise.resolve(null);

    return getJson(appUrl + '/api/earn-rate?shop=' + encodeURIComponent(shop))
      .then(function(data) {
        loyaltyRates = data;
        return loyaltyRates;
      })
      .catch(function() {
        return null;
      });
  }

  function updateRateNodes(data) {
    if (!data || !data.earnRules) return;
    const currency = document.body.dataset.shopCurrency || 'AUD';

    document.querySelectorAll('[data-loyalty-field]').forEach(function(node) {
      const field = node.dataset.loyaltyField;
      const format = node.dataset.loyaltyFormat || 'formatted';
      const rate = data.earnRules[field] && data.earnRules[field].rates && data.earnRules[field].rates[currency];
      if (!rate) return;
      node.textContent = format === 'value' ? rate.value : (rate.formatted || rate.value);
    });
  }

  function initRewardModal() {
    const modal = document.querySelector('[data-loyalty-modal]');
    const form = document.querySelector('[data-loyalty-form]');
    if (!modal || !form) return;
    const joinButtons = Array.from(document.querySelectorAll('[data-loyalty-trigger]'));
    const heroActions = document.querySelector('[data-loyalty-hero-actions]');
    const joinButton = joinButtons[0];
    const claimedStorageKey =
      joinButton && joinButton.dataset.loyaltyCustomerId
        ? 'melitta-loyalty-claimed-' + joinButton.dataset.loyaltyCustomerId
        : null;

    function markLoyaltyClaimedUi() {
      if (!joinButton) return;
      const activeLabel = joinButton.dataset.loyaltyActiveLabel || 'Rewards active';
      joinButtons.forEach(function(button) {
        button.remove();
      });
      if (heroActions && !heroActions.querySelector('[data-loyalty-active-state]')) {
        const activeState = document.createElement('span');
        activeState.className = 'button button--ghost';
        activeState.setAttribute('data-loyalty-active-state', 'true');
        activeState.textContent = activeLabel;
        heroActions.appendChild(activeState);
      }
    }

    if (claimedStorageKey && window.localStorage && window.localStorage.getItem(claimedStorageKey) === '1') {
      markLoyaltyClaimedUi();
    }

    document.querySelectorAll('[data-loyalty-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        if (trigger.tagName === 'A') return;
        event.preventDefault();
        modal.classList.add('is-open');
      });
    });

    document.querySelectorAll('[data-loyalty-close]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        modal.classList.remove('is-open');
      });
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const appUrl = document.body.dataset.loyaltyAppUrl;
      if (!appUrl) return;

      const payload = Object.assign({
        shop: document.body.dataset.permanentDomain
      }, Object.fromEntries(new FormData(form).entries()));

      const status = form.querySelector('[data-loyalty-status]');
      if (status) {
        status.hidden = false;
        status.textContent = 'Submitting your reward details...';
      }

      fetch(appUrl + '/api/account-creation-reward', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function(response) {
          return response.json().then(function(body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function(result) {
          if (!status) return;
          if (result.ok && result.body.success) {
            status.textContent = "You're in. Your loyalty reward has been added.";
            form.reset();
            if (claimedStorageKey && window.localStorage) {
              window.localStorage.setItem(claimedStorageKey, '1');
            }
            markLoyaltyClaimedUi();
            modal.classList.remove('is-open');
          } else {
            status.textContent = result.body.error || 'Unable to complete your reward request right now.';
          }
        })
        .catch(function() {
          if (status) {
            status.textContent = 'Network error. Please try again.';
          }
      });
    });
  }

  function initSubscriptionPolicyModal() {
    const modal = document.querySelector('[data-subscription-policy-modal]');
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    const dialog = modal.querySelector('.subscription-policy-modal__dialog');
    const closeTriggers = modal.querySelectorAll('[data-subscription-policy-close]');
    let lastFocusedElement = null;

    function openModal(trigger) {
      lastFocusedElement = trigger || document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.classList.add('subscription-policy-modal-open');
      if (dialog) dialog.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.classList.remove('subscription-policy-modal-open');
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[data-subscription-policy-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initAccordionPreviews(scope) {
    (scope || document).querySelectorAll('[data-accordion-root]').forEach(function(root) {
      const items = Array.from(root.querySelectorAll('.editorial-accordion__item'));
      if (!items.length || root.dataset.previewBound === 'true') return;

      root.dataset.previewBound = 'true';

      items.forEach(function(item) {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function() {
          items.forEach(function(other) {
            const otherTrigger = other.querySelector('[data-accordion-trigger]');
            const otherPanel = other.querySelector('[data-accordion-panel]');
            const isActive = other === item;

            other.classList.toggle('is-active', isActive);
            if (otherTrigger) {
              otherTrigger.setAttribute('aria-expanded', String(isActive));
            }
            if (otherPanel) {
              otherPanel.classList.toggle('is-active', isActive);
            }
          });
        });
      });
    });
  }

  function initPreviewTabs(scope) {
    (scope || document).querySelectorAll('[data-preview-tabs]').forEach(function(wrapper) {
      if (wrapper.dataset.previewBound === 'true') return;
      wrapper.dataset.previewBound = 'true';

      const buttons = Array.from(wrapper.querySelectorAll('[data-preview-switch]'));
      const panels = Array.from(wrapper.querySelectorAll('[data-preview-panel]'));

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          const targetId = button.dataset.previewTarget;

          buttons.forEach(function(other) {
            other.classList.toggle('is-active', other === button);
            other.setAttribute('aria-selected', String(other === button));
          });

          panels.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.id === targetId);
          });
        });
      });
    });
  }

  function initPreviewUi(scope) {
    initAccordionPreviews(scope);
    initPreviewTabs(scope);
  }

  function initHomeMotion(scope) {
    if (!document.body.classList.contains('template-index')) return;

    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!gsap || !ScrollTrigger || reduceMotion) return;

    if (window.__homeMotionRegistered !== true) {
      gsap.registerPlugin(ScrollTrigger);
      window.__homeMotionRegistered = true;
    }

    const root = scope || document;
    const heroCopy = document.querySelector('[data-home-hero-copy]');

    if (heroCopy && window.__homeHeroAnimated !== true) {
      window.__homeHeroAnimated = true;

      const heading = heroCopy.querySelector('[data-home-hero-heading]');
      const words = heading ? heading.querySelectorAll('.home-video-hero__word') : [];
      const sub = heroCopy.querySelector('.home-video-hero__subheading');
      const actions = heroCopy.querySelector('.home-video-hero__actions');

      const runHeroIntro = function() {
        const tl = gsap.timeline({ delay: 0.12 });
        if (words.length) {
          tl.from(words, {
            autoAlpha: 0,
            y: 28,
            duration: 0.55,
            stagger: 0.065,
            ease: 'power3.out'
          });
        } else if (heading) {
          tl.from(heading, {
            autoAlpha: 0,
            y: 44,
            duration: 0.85,
            ease: 'power3.out'
          });
        }
        const tuck = words.length ? '-=0.32' : '+=0';
        if (sub) {
          tl.from(
            sub,
            { autoAlpha: 0, y: 32, duration: 0.65, ease: 'power3.out' },
            tuck
          );
        }
        if (actions) {
          tl.from(
            actions,
            { autoAlpha: 0, y: 24, duration: 0.55, ease: 'power3.out' },
            '-=0.42'
          );
        }
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(runHeroIntro);
      } else {
        runHeroIntro();
      }
    }

    root.querySelectorAll('[data-home-stage]').forEach(function(section) {
      if (section.dataset.homeMotionBound === 'true') return;
      section.dataset.homeMotionBound = 'true';

      const stage = section.dataset.homeStage;
      let targets = [];

      if (stage === 'editorial-proof') {
        targets = [
          section.querySelector('.home-quote-carousel__header'),
          section.querySelector('.home-quote-carousel__shell')
        ];
      } else if (stage === 'product-story' || stage === 'usage-story') {
        targets = [
          section.querySelector('.home-story-split__copy'),
          section.querySelector('.home-story-split__media')
        ];
      } else if (stage === 'benefits') {
        targets = [
          section.querySelector('.home-benefits-grid__header'),
          section.querySelector('.home-benefits-grid__grid'),
          section.querySelector('.home-benefits-grid__footer')
        ];
      } else if (stage === 'customer-proof') {
        targets = [
          section.querySelector('.home-testimonial-carousel__header'),
          section.querySelector('.home-testimonial-carousel__border')
        ];
      } else if (stage === 'final-cta') {
        targets = [section.querySelector('.home-centered-cta__inner')];
      }

      targets = targets.filter(Boolean);
      if (!targets.length) return;

      var isFinalCta = stage === 'final-cta';
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      /* final-cta sits on dark --ink: autoAlpha 0 reads as an empty “black box” until GSAP runs
         (often late due to idle-loaded GSAP). Animate translate only so copy stays visible. */
      var scrollTween = {
        y: isFinalCta ? (isMobile ? 16 : 24) : (isMobile ? 20 : 52),
        duration: isFinalCta ? (isMobile ? 0.35 : 0.45) : (isMobile ? 0.55 : 0.95),
        stagger: isFinalCta ? 0 : (isMobile ? 0.08 : 0.14),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          /* final-cta: fire as soon as section enters viewport; 78% was too late — users scrolled past. Mobile fires earlier since short screens let users scroll past fast. */
          start: isFinalCta ? 'top bottom' : (isMobile ? 'top 92%' : 'top 78%'),
          once: true
        }
      };
      if (!isFinalCta) {
        scrollTween.autoAlpha = 0;
      }
      gsap.from(targets, scrollTween);

      if (window.matchMedia('(min-width: 990px)').matches) {
        const storyImage = section.querySelector('.home-story-split__media img');

        if (storyImage) {
          gsap.to(storyImage, {
            yPercent: stage === 'product-story' ? -5 : 5,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.6
            }
          });
        }
      }
    });

    ScrollTrigger.refresh();
  }

  function initProductMotion(scope) {
    if (!document.body.classList.contains('template-product')) return;

    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!gsap || !ScrollTrigger || reduceMotion) return;

    if (window.__homeMotionRegistered !== true) {
      gsap.registerPlugin(ScrollTrigger);
      window.__homeMotionRegistered = true;
    }

    const root = scope || document;
    /* ── Hero buy-box stays static above the fold. Mark it bound so the generic scroll
       animation below does not fade/shift it after first paint. ── */
    const buyBox = root.querySelector('[data-pdp-stage="buy-box"]');
    if (buyBox && !buyBox.dataset.pdpMotionBound) {
      buyBox.dataset.pdpMotionBound = 'true';
    }

    const pdpIsMobile = window.matchMedia('(max-width: 749px)').matches;

    /* ── Feature story — staggered cards ── */
    var featureStory = root.querySelector('[data-pdp-stage="pdp-feature-story"]');
    if (featureStory && !featureStory.dataset.pdpMotionBound) {
      featureStory.dataset.pdpMotionBound = 'true';

      var featureHeader = featureStory.querySelector('.pdp-features__header');
      var featureCards = featureStory.querySelectorAll('.pdp-features__card');

      if (featureHeader) {
        gsap.from(featureHeader, {
          autoAlpha: 0,
          y: pdpIsMobile ? 18 : 40,
          duration: pdpIsMobile ? 0.5 : 0.85,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: featureStory,
            start: pdpIsMobile ? 'top 92%' : 'top 80%',
            once: true
          }
        });
      }

      if (featureCards.length) {
        gsap.from(featureCards, {
          autoAlpha: 0,
          y: pdpIsMobile ? 20 : 48,
          duration: pdpIsMobile ? 0.5 : 0.75,
          stagger: pdpIsMobile ? 0.06 : 0.1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: featureStory.querySelector('.pdp-features__grid'),
            start: pdpIsMobile ? 'top 92%' : 'top 82%',
            once: true
          }
        });
      }
    }

    /* ── Testimonials ── */
    var testimonials = root.querySelector('[data-pdp-stage="pdp-testimonials"]');
    if (testimonials && !testimonials.dataset.pdpMotionBound) {
      testimonials.dataset.pdpMotionBound = 'true';

      var testiTargets = testimonials.querySelectorAll('[data-pdp-animate]');
      if (testiTargets.length) {
        gsap.from(testiTargets, {
          autoAlpha: 0,
          y: pdpIsMobile ? 18 : 44,
          duration: pdpIsMobile ? 0.55 : 0.88,
          stagger: pdpIsMobile ? 0.08 : 0.14,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: testimonials,
            start: pdpIsMobile ? 'top 92%' : 'top 78%',
            once: true
          }
        });
      }
    }

    const pdpMobile = window.matchMedia('(max-width: 749px)').matches;

    root.querySelectorAll('[data-pdp-stage]').forEach(function(section) {
      if (section.dataset.pdpMotionBound === 'true') return;
      section.dataset.pdpMotionBound = 'true';

      const targets = section.querySelectorAll('[data-pdp-animate]');
      if (!targets.length) return;

      gsap.from(targets, {
        autoAlpha: 0,
        y: pdpMobile ? 18 : 44,
        duration: pdpMobile ? 0.5 : 0.88,
        stagger: pdpMobile ? 0.07 : 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: pdpMobile ? 'top 92%' : 'top 82%',
          once: true
        }
      });
    });

    ScrollTrigger.refresh();
  }

  function initPdpStickyAtc(scope) {
    if (!document.body.classList.contains('template-product')) return;

    const root = scope || document;
    const sticky = root.querySelector('[data-pdp-sticky-atc]');
    const buyBox = root.querySelector('[data-pdp-stage="buy-box"]');
    const form = root.querySelector('form.pdp-form, form.product-form');

    if (!sticky || !buyBox || !form || sticky.dataset.stickyAtcBound === 'true') return;
    sticky.dataset.stickyAtcBound = 'true';

    const stickyButton = sticky.querySelector('[data-sticky-atc-submit]');
    const stickyLabel = sticky.querySelector('[data-sticky-atc-label]');
    const stickyPrice = sticky.querySelector('[data-sticky-product-price]');
    const stickyPlan = sticky.querySelector('[data-sticky-plan-label]');
    const stickyPlanToggles = sticky.querySelectorAll('[data-sticky-plan-toggle]');
    const submitButton = form.querySelector('[data-product-submit], [type="submit"]');
    const purchasePicker = form.querySelector('[data-selling-plan-picker]');
    const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    const planSelect = form.querySelector('[data-plan-select]');
    const mobileSheet = form.querySelector('[data-pdp-mobile-sheet]');
    const mobileSheetCloseTriggers = form.querySelectorAll('[data-pdp-mobile-sheet-close]');
    let lastFocusedElement = null;
    let mobileSheetCloseTimer = null;

    sticky.hidden = false;
    sticky.setAttribute('aria-hidden', 'true');

    function sheetEnabled() {
      return !!(mobileSheet && purchasePicker);
    }

    function openMobileSheet() {
      if (!sheetEnabled()) return false;

      if (mobileSheetCloseTimer) {
        window.clearTimeout(mobileSheetCloseTimer);
        mobileSheetCloseTimer = null;
      }

      lastFocusedElement = document.activeElement;
      mobileSheet.setAttribute('aria-hidden', 'false');
      mobileSheet.classList.remove('is-open', 'is-closing');
      mobileSheet.classList.add('is-opening');
      document.body.classList.remove('pdp-mobile-sheet-open', 'pdp-mobile-sheet-closing');
      document.body.classList.add('pdp-mobile-sheet-opening');

      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          mobileSheet.classList.add('is-open');
          document.body.classList.add('pdp-mobile-sheet-open');

          const focusTarget = form.querySelector('[data-plan-type]:checked') || form.querySelector('[data-plan-type]');
          if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
          }
        });
      });

      return true;
    }

    function closeMobileSheet(restoreFocus) {
      if (!mobileSheet) return;

      mobileSheet.setAttribute('aria-hidden', 'false');
      const wasOpen = mobileSheet.classList.contains('is-open') || document.body.classList.contains('pdp-mobile-sheet-open');
      mobileSheet.classList.remove('is-opening');
      document.body.classList.remove('pdp-mobile-sheet-opening');

      if (wasOpen && window.matchMedia('(max-width: 599px)').matches) {
        if (mobileSheetCloseTimer) window.clearTimeout(mobileSheetCloseTimer);
        mobileSheet.classList.add('is-closing');
        document.body.classList.add('pdp-mobile-sheet-closing');

        mobileSheetCloseTimer = window.setTimeout(function() {
          mobileSheet.classList.remove('is-open', 'is-closing');
          document.body.classList.remove('pdp-mobile-sheet-open', 'pdp-mobile-sheet-closing');
          mobileSheetCloseTimer = null;
        }, 380);
      } else {
        if (mobileSheetCloseTimer) {
          window.clearTimeout(mobileSheetCloseTimer);
          mobileSheetCloseTimer = null;
        }
        mobileSheet.classList.remove('is-open', 'is-closing');
        document.body.classList.remove('pdp-mobile-sheet-open', 'pdp-mobile-sheet-closing');
      }

      if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function headerOffset() {
      const shell = document.querySelector('.storefront-header');
      if (!shell || shell.classList.contains('is-scroll-hidden')) return 0;
      return shell.getBoundingClientRect().height || 0;
    }

    function syncStickyLabel() {
      if (!stickyButton) return;

      if (submitButton) {
        stickyButton.disabled = submitButton.disabled;
      }

      if (!stickyLabel) return;
      if (stickyButton.disabled) {
        stickyLabel.textContent = stickyButton.dataset.labelUnavailable || 'Unavailable';
        return;
      }

      if (sheetEnabled()) {
        stickyLabel.textContent = stickyButton.dataset.labelMobile || 'Choose options';
        return;
      }

      stickyLabel.textContent = stickyButton.dataset.labelAvailable || 'Add to cart';
    }

    function selectedPurchaseType() {
      const checked = form.querySelector('[data-plan-type]:checked');
      return checked && checked.dataset.planType === 'onetime' ? 'onetime' : 'subscribe';
    }

    function syncPurchaseState() {
      const type = selectedPurchaseType();
      const subscribeSelected = type === 'subscribe';

      if (sellingPlanInput) {
        sellingPlanInput.disabled = !subscribeSelected;
        if (subscribeSelected && planSelect && planSelect.value) {
          sellingPlanInput.value = planSelect.value;
        } else if (!subscribeSelected) {
          sellingPlanInput.value = '';
        }
      }

      if (purchasePicker) {
        purchasePicker.classList.toggle('pdp-purchase-options--one-time-active', !subscribeSelected);
      }

      stickyPlanToggles.forEach(function(toggle) {
        const isActive = toggle.dataset.stickyPlanToggle === type;
        toggle.classList.toggle('is-active', isActive);
        toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const priceSource = subscribeSelected
        ? form.querySelector('[data-plan-sub-price]')
        : form.querySelector('[data-plan-onetime-price], [data-product-price]');

      if (stickyPrice && priceSource) {
        stickyPrice.textContent = priceSource.textContent.trim();
      }

      if (stickyPlan) {
        const label = subscribeSelected ? 'Subscribe' : 'One-time';
        stickyPlan.textContent = label;
        stickyPlan.hidden = false;
      }
    }

    function updateVisibility() {
      const rect = buyBox.getBoundingClientRect();
      const shouldShow = rect.bottom <= headerOffset() + 8;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (stickyButton) stickyButton.tabIndex = shouldShow ? 0 : -1;
      document.body.classList.toggle('pdp-sticky-on', shouldShow);
    }

    let ticking = false;
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        syncPurchaseState();
        syncStickyLabel();
        updateVisibility();
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function() {
        if (stickyButton.disabled) return;

        if (openMobileSheet()) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitButton || undefined);
        } else if (submitButton) {
          submitButton.click();
        }
      });
    }

    stickyPlanToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const targetType = toggle.dataset.stickyPlanToggle;
        const targetRadio = form.querySelector('[data-plan-type="' + targetType + '"]');

        if (targetRadio && !targetRadio.checked) {
          targetRadio.checked = true;
          targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncPurchaseState();
        syncStickyLabel();
      });
    });

    if (planSelect) {
      planSelect.addEventListener('change', function() {
        if (sellingPlanInput && selectedPurchaseType() === 'subscribe') {
          sellingPlanInput.value = planSelect.value;
        }
        requestUpdate();
      });
    }

    form.addEventListener('change', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function() {
      requestUpdate();
    });

    mobileSheetCloseTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        closeMobileSheet(true);
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && document.body.classList.contains('pdp-mobile-sheet-open')) {
        closeMobileSheet(true);
      }
    });

    if (typeof MutationObserver !== 'undefined' && submitButton) {
      var observer = new MutationObserver(requestUpdate);
      observer.observe(submitButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    }

    syncPurchaseState();
    syncStickyLabel();
    updateVisibility();
  }

  function closeMobileMenu(restoreFocus) {
    const btn = document.querySelector('[data-mobile-menu-button]');
    const panel = document.querySelector('[data-mobile-menu]');
    if (!btn || btn.getAttribute('aria-expanded') !== 'true') return;
    btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-menu-open');
    if (restoreFocus) btn.focus();
  }

  function openMobileMenu() {
    const btn = document.querySelector('[data-mobile-menu-button]');
    const panel = document.querySelector('[data-mobile-menu]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-menu-open');
    if (panel) {
      requestAnimationFrame(function() {
        const firstFocusable = panel.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      });
    }
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openCart();
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
    }

    const menuButton = event.target.closest('[data-mobile-menu-button]');
    if (menuButton) {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      if (expanded) closeMobileMenu(false);
      else openMobileMenu();
    }

    if (event.target.closest('[data-mobile-menu-backdrop]')) {
      closeMobileMenu(false);
    }

    if (event.target.closest('[data-mobile-menu] a')) {
      closeMobileMenu(false);
    }

    var minusBtn = event.target.closest('[data-qty-minus]');
    if (minusBtn) {
      var stepper = minusBtn.closest('.qty-stepper');
      var input = stepper && stepper.querySelector('.qty-stepper__input, [data-cart-quantity]');
      if (input) {
        input.value = safeQuantity(input.value) - 1;
        input.value = safeQuantity(input.value);
        debouncedCartUpdate(input.dataset.key, safeQuantity(input.value));
      }
    }

    var plusBtn = event.target.closest('[data-qty-plus]');
    if (plusBtn) {
      var stepperP = plusBtn.closest('.qty-stepper');
      var inputP = stepperP && stepperP.querySelector('.qty-stepper__input, [data-cart-quantity]');
      if (inputP) {
        inputP.value = safeQuantity(inputP.value) + 1;
        debouncedCartUpdate(inputP.dataset.key, safeQuantity(inputP.value));
      }
    }

    var pageMinusBtn = event.target.closest('[data-qty-page-minus]');
    if (pageMinusBtn) {
      var pStepper = pageMinusBtn.closest('.qty-stepper');
      var pInput = pStepper && pStepper.querySelector('.qty-stepper__input');
      if (pInput) {
        pInput.value = safeQuantity(pInput.value) - 1;
        pInput.value = safeQuantity(pInput.value);
      }
    }

    var pagePlusBtn = event.target.closest('[data-qty-page-plus]');
    if (pagePlusBtn) {
      var pStepperP = pagePlusBtn.closest('.qty-stepper');
      var pInputP = pStepperP && pStepperP.querySelector('.qty-stepper__input');
      if (pInputP) {
        pInputP.value = safeQuantity(pInputP.value) + 1;
      }
    }

    const pageRemoveButton = event.target.closest('[data-cart-page-remove]');
    if (pageRemoveButton) {
      const item = pageRemoveButton.closest('.cart-item');
      const form = pageRemoveButton.closest('form');
      const input = item && item.querySelector('input[name="updates[]"]');
      if (input && form) {
        input.value = '0';
        form.submit();
      }
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      const key = removeButton.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function(response) {
          return response.json();
        })
        .then(renderCart);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeMobileMenu(true);
      return;
    }

    if (event.key === 'Tab') {
      const btn = document.querySelector('[data-mobile-menu-button]');
      if (!btn || btn.getAttribute('aria-expanded') !== 'true') return;
      const panel = document.querySelector('[data-mobile-menu]');
      if (!panel) return;
      const focusables = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;
    const menuButton = event.target.closest('[data-mobile-menu-button]');
    if (!menuButton) return;
    event.preventDefault();
    menuButton.click();
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth >= 990) closeMobileMenu(false);
  });

  var _cartTimers = {};
  var _cartInflight = false;
  var _cartPendingQueue = null;

  function debouncedCartUpdate(key, qty) {
    if (_cartTimers[key]) clearTimeout(_cartTimers[key]);
    _cartTimers[key] = setTimeout(function() {
      delete _cartTimers[key];
      flushCartUpdate(key, qty);
    }, 500);
  }

  function flushCartUpdate(key, qty) {
    if (_cartInflight) {
      _cartPendingQueue = { key: key, qty: qty };
      return;
    }
    _cartInflight = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        _cartInflight = false;
        if (_cartPendingQueue) {
          var next = _cartPendingQueue;
          _cartPendingQueue = null;
          flushCartUpdate(next.key, next.qty);
        }
        renderCart(cart);
      })
      .catch(function() { _cartInflight = false; });
  }

  document.addEventListener('change', function(event) {
    const quantityInput = event.target.closest('[data-cart-quantity]');
    if (quantityInput) {
      quantityInput.value = safeQuantity(quantityInput.value);
      debouncedCartUpdate(quantityInput.dataset.key, safeQuantity(quantityInput.value));
    }
  });

  document.addEventListener('submit', function(event) {
    const form = event.target.closest('form');
    if (!isProductForm(form)) return;
    event.preventDefault();
    submitProductForm(form);
  });

 
  function initPdpSubscriptionsCollapsible(scope) {
    var roots = (scope || document).querySelectorAll('[data-pdp-subscriptions-collapsible]');
    roots.forEach(function(root) {
      if (root.dataset.subsCollapsibleBound === 'true') return;

      var mount = root.querySelector('.subscriptions_app_embed_block');
      if (!mount) return;

      function bind() {
        var section =
          mount.querySelector('section.shopify_subscriptions_app_block') ||
          mount.querySelector('[class*="shopify_subscriptions_app_block"]') ||
          mount;

        var labels = section.querySelectorAll('.shopify_subscriptions_app_block_label');
        if (labels.length < 2) return false;

        if (root.dataset.subsCollapsibleBound === 'true') return true;

        var oneTimeLabel = labels[0];
        var subscribeLabel = labels[1];
        var policyEl = section.querySelector('.shopify_subscriptions_app_policy');

        var oneTimeRadio = oneTimeLabel.querySelector('input[type="radio"]');
        if (!oneTimeRadio) return false;

        var subscribeRadio = subscribeLabel.querySelector('input[type="radio"]');

        var children = Array.prototype.slice.call(subscribeLabel.children);
        var deliveryEls = [];

        if (children.length > 1) {
          for (var i = 1; i < children.length; i++) {
            deliveryEls.push(children[i]);
          }
        }

        if (!deliveryEls.length) {
          var radios = subscribeLabel.querySelectorAll('input[type="radio"]');
          for (var j = 0; j < radios.length; j++) {
            var p = radios[j].parentElement;
            if (p && p !== subscribeLabel && deliveryEls.indexOf(p) === -1) {
              deliveryEls.push(p);
            }
          }
          if (deliveryEls.length && deliveryEls[0] === (subscribeRadio && subscribeRadio.parentElement)) {
            deliveryEls.shift();
          }
        }

        deliveryEls.forEach(function(el) {
          el.setAttribute('data-pdp-subs-collapsible-row', 'true');
        });

        if (policyEl && policyEl.dataset.pdpSubsPolicyOriginal === undefined) {
          policyEl.dataset.pdpSubsPolicyOriginal = policyEl.textContent.trim();
        }

        var oneTimeCopy = root.dataset.pdpSubsOnetimePolicy || '';
        var subscribeCopy =
          root.dataset.pdpSubsSubscribePolicy ||
          (policyEl && policyEl.dataset.pdpSubsPolicyOriginal) || '';

        function update() {
          var isOneTime = oneTimeRadio.checked;
          root.classList.toggle('is-one-time-selected', isOneTime);

          if (policyEl) {
            policyEl.textContent = isOneTime
              ? (oneTimeCopy || 'One-time purchase.')
              : (policyEl.dataset.pdpSubsPolicyOriginal || subscribeCopy || '');
          }
        }

        section.addEventListener('change', function(e) {
          if (e.target && e.target.type === 'radio') update();
        });
        update();

        root.dataset.subsCollapsibleBound = 'true';
        return true;
      }

      if (bind()) return;

      var obs = new MutationObserver(function() {
        if (bind()) obs.disconnect();
      });
      obs.observe(mount, { childList: true, subtree: true });
      setTimeout(function() { obs.disconnect(); }, 45000);
    });
  }

  function initStorefrontHeaderScroll() {
    var shell = document.getElementById('StorefrontHeader');
    if (!shell || shell.dataset.headerScrollBound === 'true') return;
    shell.dataset.headerScrollBound = 'true';

    var reduceMotion = false;
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      reduceMotion = false;
    }

    var lastY = window.scrollY || document.documentElement.scrollTop || 0;
    var ticking = false;
    var deltaThreshold = 8;
    var topAlwaysVisiblePx = 56;

    function isMobileMenuOpen() {
      var btn = document.querySelector('[data-mobile-menu-button]');
      return btn && btn.getAttribute('aria-expanded') === 'true';
    }

    function updateOffsets() {
      var h = shell.offsetHeight;
      document.documentElement.style.setProperty('--storefront-header-height', h + 'px');
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    function onScrollFrame() {
      ticking = false;
      if (reduceMotion) {
        lastY = window.scrollY || document.documentElement.scrollTop || 0;
        return;
      }

      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var delta = y - lastY;

      if (y <= topAlwaysVisiblePx) {
        shell.classList.remove('is-scroll-hidden');
      } else if (document.body.classList.contains('is-cart-open')) {
        shell.classList.remove('is-scroll-hidden');
      } else if (isMobileMenuOpen()) {
        shell.classList.remove('is-scroll-hidden');
      } else if (delta > deltaThreshold) {
        shell.classList.add('is-scroll-hidden');
      } else if (delta < -deltaThreshold) {
        shell.classList.remove('is-scroll-hidden');
      }

      lastY = y;
    }

    window.addEventListener(
      'scroll',
      function() {
        if (reduceMotion) return;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(onScrollFrame);
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', updateOffsets);
    if (typeof ResizeObserver !== 'undefined') {
      try {
        var ro = new ResizeObserver(updateOffsets);
        ro.observe(shell);
      } catch (e) {}
    }

    updateOffsets();
    window.addEventListener('load', function() {
      updateOffsets();
      setTimeout(updateOffsets, 150);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initStorefrontHeaderScroll();
    document.querySelectorAll('form.pdp-form, form.product-form').forEach(syncProductForm);
    fetchLoyaltyRates().then(function(data) {
      updateRateNodes(data);
      if (document.querySelector('.cart-page, .cart-panel')) {
        getJson('/cart.js').then(function(cart) {
          updateShippingBar(cart.total_price, cart.currency);
        }).catch(function() {});
      }
    });
    initRewardModal();
    initSubscriptionPolicyModal();
    initPreviewUi(document);
    initHomeMotion(document);
    initProductMotion(document);
    initPdpStickyAtc(document);
    initPdpSubscriptionsCollapsible(document);
  });

  /* GSAP loads lazily (see layout/theme.liquid) — rerun motion setup once it arrives. */
  document.addEventListener('gsap:ready', function() {
    initHomeMotion(document);
    initProductMotion(document);
  });

  window.addEventListener('load', function() {
    initPdpSubscriptionsCollapsible(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initPreviewUi(event.target);
    initHomeMotion(event.target);
    initProductMotion(event.target);
    initPdpSubscriptionsCollapsible(event.target);
    var shell = document.getElementById('StorefrontHeader');
    if (shell && shell.contains(event.target)) {
      var h = shell.offsetHeight;
      document.documentElement.style.setProperty('--storefront-header-height', h + 'px');
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
  });
})();
